// extracted by mini-css-extract-plugin
module.exports = {"ratingChat":"_2SOhP","bubble":"dAm9J","header":"_3Ic8B","avatar":"_1Iihd","headerText":"_1jBaS","headerRatingDate":"_3FR9i","text":"_3dtUs"};